import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NasModelModule } from '@sama/ng-app-state';
import { SharedModule } from '../../shared/shared.module';
import { NestableOutputComponent } from './nestable-output.component';
import { CheckboxOuputValueAccessorComponent } from './nestable-outputs/checkbox-output/checkbox-output-value-accessor.component';
import { CheckboxOutputComponent } from './nestable-outputs/checkbox-output/checkbox-output.component';
import { DropdownOutputComponent } from './nestable-outputs/dropdown-output/dropdown-output.component';
import { MultilevelMenuOutputComponent } from './nestable-outputs/multilevel-menu/multilevel-menu-output.component';
import { PowerlistMenuComponent } from './nestable-outputs/multilevel-menu/powerlist-menu.component';
import { RadioButtonsOutputComponent } from './nestable-outputs/radio-buttons-output/radio-buttons-output.component';
import { TagLibraryOutputComponent } from './nestable-outputs/tag-library-output/tag-library-output.component';
import { TextAreaOutputComponent } from './nestable-outputs/text-area-output/text-area-output.component';
import { TextfieldOutputComponent } from './nestable-outputs/textfield-output/textfield-output.component';
import { TrainingAnswerIconComponent } from './nestable-outputs/training-answer-icon.component';

const exportedItems = [NestableOutputComponent];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatAutocompleteModule,
    NasModelModule,
    MatChipsModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  declarations: [
    exportedItems,
    CheckboxOutputComponent,
    CheckboxOuputValueAccessorComponent,
    DropdownOutputComponent,
    MultilevelMenuOutputComponent,
    PowerlistMenuComponent,
    RadioButtonsOutputComponent,
    TextfieldOutputComponent,
    TagLibraryOutputComponent,
    TextAreaOutputComponent,
    TrainingAnswerIconComponent,
  ],
  exports: [exportedItems],
})
export class NestableOutputsModule {}
